import React from "react";
import { useAuthDatas } from "../auth/JWTAuthProvider";
import useRouteGenerator from "../shared/utils/routeGenerator";
import { Navigate, useLocation } from "react-router-dom";
import Loading from "./components/Loading";
import MainLayout from "./MainLayout";
import { authRoutes } from "../pages/auth";
import { mainRoutes } from "../pages/main";
import { errorRoutes } from "../pages/error";
import AdminLayout from "./AdminLayout";

function AppLayout() {
  const { isAuthenticated, isLoading, user } = useAuthDatas();

  const { pathname } = useLocation();

  const isMainLayout =
    pathname.startsWith("/main") || pathname.startsWith("/error");

    const hasAccess = (routeRoles, userRole) => {
        if (!routeRoles) return true;
        if (userRole === "admin" || userRole === "superadmin") return true;
        return routeRoles.includes(userRole);
    };
    const filteredMainRoutes = mainRoutes.map((route) => {
        if (hasAccess(route.roles, user?.role)) {
            return route;
        }

        return {
            path: route.path,
            element: <Navigate to="/error/not-found" />,
        };
    });


    const routes = useRouteGenerator(
        isAuthenticated
            ? [
                ...errorRoutes,
                ...filteredMainRoutes,
                ...authRoutes.map((route) => ({
                    path: route.path,
                    element: <Navigate to="/main/all-apartments" />,
                })),
                {
                    path: "/",
                    element: <Navigate to="/main/all-apartments" />,
                },
                {
                    path: "*",
                    element: <Navigate to="/error/not-found" />,
                },
            ]
            : [
                ...errorRoutes,
                ...authRoutes,
                ...mainRoutes.map((route) => ({
                    path: route.path,
                    element: <Navigate to="/auth/login" />,
                })),
                {
                    path: "/",
                    element: <Navigate to="/auth/login" />,
                },
                {
                    path: "*",
                    element: <Navigate to="/error/not-found" />,
                },
            ]
    );


    if (isLoading) {
    return <Loading></Loading>;
  }

  if (!isAuthenticated) {
    return <div> {routes}</div>;
  }

  return isMainLayout ? (
    <AdminLayout>{routes}</AdminLayout>
  ) : (
    <div> {routes}</div>
  );
}

export default AppLayout;
